import { observer } from 'mobx-react-lite';
import type { ShiritoriGameStore } from '@/game/core/game.store';
import { SpinLoader } from '@/components/loader/spin-loader';
import { ShiritoriBoard } from '@/components/board/shiritori-board';
import { WordSearchPanel } from '@/components/board/word-search-panel';
import { SpectatePanel } from '@/components/board/spectate-panel';
import { EndGameModal } from '@/components/board/end-game-modal';
import { LeaveGameDialog } from '@/components/leave-game-dialog';
import { useEffect, useState } from 'react';
import { ShowEndGameButton } from '@/components/home/buttons';

interface GameplayProps {
    game: ShiritoriGameStore;
}

export const Gameplay = observer(function ({ game }: GameplayProps) {
    const [isEndGameModalOpen, setEndGameModalOpen] = useState(false);
    const [completedFeedbackTurn, setCompletedFeedbackTurn] = useState<string>();
    const latestTurn = game.turns[game.lastTurnIndex];
    const endTurnKey = latestTurn && (latestTurn.word || latestTurn.timedOutAt)
        ? `${latestTurn.index}-${latestTurn.playedAt}`
        : undefined;
    const isEndFeedbackComplete = game.hasForfeit || !endTurnKey || completedFeedbackTurn === endTurnKey;

    useEffect(() => {
        if (game.isGameOver && isEndFeedbackComplete) {
            setEndGameModalOpen(true);
        }
    }, [game.isGameOver, isEndFeedbackComplete]);

    if (!game.hasData) {
        return (
            <div className="w-full h-full flex items-center justify-center">
                <SpinLoader className="w-8 h-8" />
            </div>
        );
    }

    return (
        <div className="min-h-full w-full">
            {!game.isGameOver && <LeaveGameDialog game={game} />}
            <div className="mx-auto max-w-6xl px-4 py-6">
                <div className="grid gap-6 items-start lg:grid-cols-[1.15fr,0.85fr]">
                    <ShiritoriBoard game={game} onPlayFeedbackComplete={setCompletedFeedbackTurn} />
                    {!game.isGameOver && game.isDeviceTurn && <WordSearchPanel game={game} />}
                    {!game.isGameOver && !game.isDeviceTurn && <SpectatePanel game={game} />}
                    {game.isGameOver && isEndFeedbackComplete && !isEndGameModalOpen && <ShowEndGameButton onClick={() => setEndGameModalOpen(true)} />}
                </div>
            </div>
            {isEndGameModalOpen && <EndGameModal game={game} onDismiss={() => setEndGameModalOpen(false)} />}
        </div>
    );
});
